// numbers and characters
export const REGEX_INTEGERS = /^[0-9]*$/;
export const REGEX_PROPERTY_SUBCLASS = /[+-]/g;
export const REGEX_EMAIL_FORMAT = /^[^\s@]+@[^\s@]+\.[^\s@]+$/g;
export const REGEX_EMPTY_SPACES = /\s/g;
export const REGEX_DECIMALS = /^(\d+(\.\d{0,2})?|\.?\d{1,2})$/;
export const REGEX_DECIMALS_WITH_COMMA = /^\d+(,\d+)*(,|\.\d{0,2})?$/;
export const REGEX_PERCENTAGE = /^(100(\.0{0,2})?|\d{1,2}(\.\d{0,2})?|0(\.\d{1,2})?)$/;
export const REGEX_NEGATIVE_PERCENTAGE = /^-?\d+$/;
export const REGEX_THREE_DECIMALS = /^(\d+(\.\d{0,3})?|\.?\d{1,2})$/;
export const REGEX_THOUSAND_SEP = /\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g;
export const REGEX_THOUSAND_SEP_WITH_DECIMALS = /^(\d*,?(,?\d+)*,?(\d+(\.?\d{0,2}))?|\.?\d{1,2})$/;
export const REGEX_CURRENCY = /^(?:\d{1,3}){1}(?:([,]\d{3})+)?([.]\d{1,2})?$/;
export const REGEX_NON_DIGITS = /\D/g;
export const ONLY_DIGITS_REGEX = /^\d+$/;
export const SPECIAL_CHARS = /[{([\])}]/g;
export const REGEX_NON_ALPHANUMERIC_DASH = /[^a-z0-9-]/gi;

// pages
export const PROPERTY_PAGE_URL_REG_EXP = /\/properties\/\d+\/(?=([A-Za-z\-](#)?[A-Za-z\-]))/;
export const COMPANY_PATH_REG_EXP = /\/companies\/\d+(?=(\/[A-Za-z\-]))?/;
export const MARKET_PAGE_URL_REG_EXP = /\/markets\/\d+\/(?=([A-Za-z\-]))/;
export const COMP_SET_PAGE_URL_REG_EXP = /\/properties\/\d+\/comp-sets\/\d+\/(?=([A-Za-z\-](#)?[A-Za-z\-]))/;
export const SUBMARKET_PAGE_URL_REG_EXP = /\/submarkets\/\d+\/\d+\/(?=([A-Za-z\-]))/;
export const TENANT_TOUR_URL_REG_EXP = /\/companies\/\d+\/tenant-tours\/\d+\/(?=([A-Za-z\-]))/;

// formatters
export const REGEX_PROTOCOL = /^\/\/|^.*?:(\/\/)?/;
export const REGEX_TRAILING_SLASH = /\/+$/;

// find comps
export const AREA_SEARCH_REGEX = /areaSearch(\d+)=([^&]*?)(?=&|$)/g;
export const AREA_SEARCH_DATA_REGEX_ = /areaSearchData\.([^=]+)=([^&]*?)(?=&|$)/g;
export const CUSTOM_CRITERIA_PARAM = /c\[([^\]]+)\]/;
export const OPEN_SELECTION_CRITERIA_PARAM = /o\[([^\]]+)\]/;
export const LEASES_CRITERIA_PARAM = /l\[([^\]]+)\]/;
export const SALES_CRITERIA_PARAM = /s\[([^\]]+)\]/;
export const TIMS_CRITERIA_PARAM = /t\[([^\]]+)\]/;
export const DOCUMENTS_CRITERIA_PARAM = /d\[([^\]]+)\]/;

export const LOGO_DEV_DOMAIN = /logo\.dev/i;
export const LOCALHOST_URL = /^(https?:\/\/)?localhost[:/]/i;

// abstraction
export const MARKDOWN_FENCED_JSON = /```(?:json)?\s*([\s\S]*?)```/i;
